import useTestId from '@ori/testid-generator';
import { type FC } from 'react';

import { useFooter } from '../../hooks';
import { ContentRoot } from '../ContentRoot';
import { COPYRIGHT_WITH_LINKS } from './constants';
import { CopyrightTitle, Inner, Links, StyledLink } from './styles';

export const CopyrightWithLinks: FC = () => {
  const { copyrightLinks, copyrightTitle } = useFooter();
  const { getTestId } = useTestId();

  if (!copyrightTitle) {
    return null;
  }

  return (
    <ContentRoot testId={getTestId(COPYRIGHT_WITH_LINKS)}>
      <Inner>
        <CopyrightTitle>{copyrightTitle}</CopyrightTitle>
        {copyrightLinks.length > 0 ? (
          <Links>
            {copyrightLinks.map((link) => (
              <StyledLink
                key={link.title}
                href={link.url ?? ''}
                title={link.title}
              >
                {link.title}
              </StyledLink>
            ))}
          </Links>
        ) : null}
      </Inner>
    </ContentRoot>
  );
};
